export default "__VITE_ASSET__X61mwJ2s__"